import { createAction, props } from '@ngrx/store';

import { InstitutionDto, TestPurposeDto, TestSessionForRegistrationDto } from '../core/dtos/dto';
import { TestPurposeEnum } from '../core/dtos/enum';
import { ProofOfIdentityPageSaveInfo, ScoreReportPageSaveInfo } from '../core/dtos/reg-data';
import { TestPurposeOption } from '../core/dtos/test-purpose-option';

export const setTestPurposeOption = createAction(
  '[Reg Data] Set Test Purpose Option',
  props<{ testPurposeOption: TestPurposeOption }>()
);

export const setRegTestSession = createAction(
  '[Reg Data] Set Test Session',
  props<{ testSession: TestSessionForRegistrationDto }>()
);

export const setProofOfIdentity = createAction(
  '[Reg Data] Set Proof of Identity',
  props<{ proofOfIdentity: ProofOfIdentityPageSaveInfo }>()
);

export const setTestPurposeLookup = createAction(
  '[Reg Data] Set Test Purpose & Institution Lookup',
  props<{ testPurposes: TestPurposeDto[]; institutions: InstitutionDto[]; subscribedInstitutions: Map<TestPurposeEnum, InstitutionDto[]> }>()
);

export const setScoreReport = createAction(
  '[Reg Data] Set Score Report',
  props<{ scoreReport: ScoreReportPageSaveInfo }>()
);

export const setTestTypeId = createAction(
  '[Reg Data] Set Test Type Id',
  props<{ testTypeId: number }>()
);

export const setRegId = createAction(
  '[Reg Data] Set Reg Id',
  props<{ regId: number }>()
);


export const clearRegData = createAction('[Reg Data] Clear Reg Data');
